// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_info-box_btn-primary__1HTPh","container":"_info-box_container__2XZE_","icon":"_info-box_icon__hhP_y"};